const ADMIN_SESSION_KEY = "hevmed_admin_session";
const ADMIN_MODE_KEY = "hevmed_admin_mode";

const readFlag = (key) => {
  try {
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
};

const writeFlag = (key, active) => {
  try {
    if (active) localStorage.setItem(key, "true");
    else localStorage.removeItem(key);
  } catch {
    // ignore storage errors (private browsing, etc.)
  }
};

export const isAdminSessionActive = () => readFlag(ADMIN_SESSION_KEY);

export const setAdminSession = (active) => writeFlag(ADMIN_SESSION_KEY, active);

export const isAdminModeActive = () => readFlag(ADMIN_MODE_KEY);

export const setAdminMode = (active) => writeFlag(ADMIN_MODE_KEY, active);

export const clearAdminAuth = () => {
  writeFlag(ADMIN_SESSION_KEY, false);
  writeFlag(ADMIN_MODE_KEY, false);
};
